import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import MenteePortalService, { MenteeLanding } from './MenteePortalService';

/**
 * Mentors index: three-way landing (DEC-P16-002).
 * dashboard → /dashboard; otherwise → /register (awaiting or form).
 */
const MenteeLandingRedirect = () => {
    const [landing, setLanding] = useState<MenteeLanding | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [ineligible, setIneligible] = useState(false);
    const [forbidden, setForbidden] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        MenteePortalService.getDashboard()
            .then((data) => {
                if (cancelled) return;
                setLanding(data.landing);
                setError(null);
            })
            .catch((err: { status?: number; message?: string }) => {
                if (cancelled) return;
                const status = err?.status;
                const message = MenteePortalService.errorMessage(err);
                if (status === 403 && /ineligible/i.test(message)) {
                    setIneligible(true);
                    return;
                }
                if (status === 403 || status === 401) {
                    setForbidden(true);
                    return;
                }
                // Form-eligible students may hit portal issues; fall through to registration.
                setLanding('registration_form');
                setError(null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return <p className="mreg-sub">Loading…</p>;
    }
    if (ineligible) {
        return (
            <p className="mreg-sub">
                The mentorship program is not available for your campus.
            </p>
        );
    }
    if (forbidden) {
        return <p className="mreg-sub">You do not have access to Mentorship.</p>;
    }
    if (error) {
        return <p className="mreg-banner is-danger">{error}</p>;
    }
    if (landing === 'dashboard') {
        return <Navigate to="dashboard" replace />;
    }
    return <Navigate to="register" replace />;
};

export default MenteeLandingRedirect;
